import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFiltersIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 33 32",
	stroke: "#0C5661",
	fill: "#79FBAF",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .75,
			width: 32,
			height: 32,
			rx: 10,
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1684 20.6354H9.19931",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8307 11.4529H23.7997",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.6485 11.4017C13.6485 10.1743 12.6461 9.17896 11.4098 9.17896C10.1735 9.17896 9.17099 10.1743 9.17099 11.4017C9.17099 12.6292 10.1735 13.6245 11.4098 13.6245C12.6461 13.6245 13.6485 12.6292 13.6485 11.4017Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.3292 20.5983C24.3292 19.3708 23.3275 18.3755 22.0911 18.3755C20.8541 18.3755 19.8517 19.3708 19.8517 20.5983C19.8517 21.8257 20.8541 22.821 22.0911 22.821C23.3275 22.821 24.3292 21.8257 24.3292 20.5983Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFiltersIcon;
